import { useState, useCallback } from 'react';
import { useWorkOrderBase } from './workOrderBase';
import { useWorkOrderCRUD } from './useWorkOrderCRUD';
import { useWorkOrderOperations } from './useWorkOrderOperations';
import { useWorkOrderOperationManagement } from './useWorkOrderOperationManagement';
import { useWorkOrderJobCards } from './useWorkOrderJobCards';
import { useWorkOrderMaterials } from './useWorkOrderMaterials';
import { useWorkOrderQC } from './useWorkOrderQC';

/**
 * Combined hook for work order management that combines all the specialized hooks.
 * This provides a single interface for components that need full work order functionality.
 */
export const useWorkOrders = () => {
  // Get the base shared state
  const baseState = useWorkOrderBase();

  // Get all the specialized hooks with the shared base state
  const crud = useWorkOrderCRUD(baseState);
  const operations = useWorkOrderOperations(baseState);
  const operationManagement = useWorkOrderOperationManagement(baseState);
  const jobCards = useWorkOrderJobCards(baseState);
  const materials = useWorkOrderMaterials(baseState);
  const qc = useWorkOrderQC(baseState);

  // Return a merged object with all the functionality
  return {
    // Base state
    ...baseState,
    
    // CRUD operations
    ...crud,
    
    // Operations status
    ...operations,
    
    // Operation management
    ...operationManagement,
    
    // Job cards
    ...jobCards,
    
    // Materials
    ...materials,
    
    // QC
    ...qc,
  };
};
